package org.hs_soft.runmynesto.domain.model.home.product

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.model.general.TitleEnum
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class ProductInfoHeaderEnum : TitleEnum {
    GENERAL,
    CHECKOUT,
    RESTAURANT,
    PRICE,
    SELECTION,
//    CLICK_AND_CONNECT,
    ALLERGENES;



    override val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                GENERAL -> strings.general
                CHECKOUT -> strings.devices
                PRICE->strings.price
                RESTAURANT -> strings.restaurant
                SELECTION->strings.selection
//                CLICK_AND_CONNECT -> strings.clickAndCollect
                ALLERGENES -> strings.allergens
            }
        }
}